export const cSharpInt32Max = 2147483647;